import {
  AddOneSlotToLoadingQueue,
  RemoveOneSlotToLoadingQueue,
} from "../../loading/loading.store";
import ShowNotification from "../../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../../utils/configuration";
import { ApiUrl } from "../../../../api/api-url";
import Service from "../../../../api/api-service";
import { CONSTANT } from "../../../../constants/constant";
const service = new Service();

export const GET_LOOKUP_PROVINCE_OK = "GET_LOOKUP_PROVINCE_OK";
export const GET_LOOKUP_PROVINCE_ERR = "GET_LOOKUP_PROVINCE_ERR";

export const lookupProvinceAction = {
  getLookupProvince,
};

function getLookupProvinceOk(payload) {
  return { type: GET_LOOKUP_PROVINCE_OK, payload };
}
function getLookupProvinceErr(payload) {
  return { type: GET_LOOKUP_PROVINCE_ERR, payload };
}

function getLookupProvince(data) {
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .get(ApiUrl.GetLookupProvinceAdm)
      .then((response) => {
        dispatch(getLookupProvinceOk(response));
        dispatch(RemoveOneSlotToLoadingQueue);
      })
      .catch((error) => {
        dispatch(getLookupProvinceErr(error));
        dispatch(RemoveOneSlotToLoadingQueue);
        if (error && error.errorMessage) {
          ShowNotification(error.errorMessage, NotificationMessageType.Error);
        } else {
          ShowNotification(
            CONSTANT.message.error_unknown,
            NotificationMessageType.Error
          );
        }
      });
  };
}
